/* Copyright (c) 2023 MOCA Systems, Inc. All rights reserved. */
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Functions } from '@angular/fire/functions';

import { FirebaseCloudFunctionsService } from './cloud-functions.service';
import {
	ICompleteSignUpUser,
	ICreateUserParams,
	ICompleteSignUpParams,
	ICompleteSignUpResponse,
} from '@touchplan/common';

@Injectable({
	providedIn: 'root',
})
export class UserFirebaseCloudFunctionsService {
	private functionsInstance: Functions = inject(Functions);

	/**
	 * Creates a new user with the provided data.
	 *
	 * @param userData - Parameters for creating the user.
	 * @returns An observable that emits the created user.
	 */
	public createUser(userData: ICreateUserParams) {
		return FirebaseCloudFunctionsService.callFunctionAsObservable$<ICreateUserParams, ICompleteSignUpUser>(
			this.functionsInstance,
			'mb4-createUser',
			userData
		);
	}

	/**
	 * Completes the sign-up process for a user with the provided data.
	 *
	 * @param userData - Parameters for completing the sign-up process.
	 * @returns An observable that emits the response when the sign-up process is successfully completed.
	 */
	public completeSignUp(userData: ICompleteSignUpParams): Observable<ICompleteSignUpResponse> {
		return FirebaseCloudFunctionsService.callFunctionAsObservable$<
			ICompleteSignUpParams,
			ICompleteSignUpResponse
		>(this.functionsInstance, 'mb4-completeSignUp', userData);
	}
}
